import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-between q-pa-sm no-wrap non-selectable floating-window-header" }
const _hoisted_2 = { class: "overflow-hidden" }
const _hoisted_3 = { class: "floating-window-body" }
const _hoisted_4 = { class: "full-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["floating-window", { smooth: _ctx.fullscreenProcessing, fullscreen: _ctx.fullscreenProcessing }]),
    style: _normalizeStyle(_ctx.computedContainerStyle)
  }, [
    _createElementVNode("div", {
      class: "floating-window-border",
      style: _normalizeStyle(_ctx.computedBorderStyle)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (!_ctx.fullscreenMode)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                class: _normalizeClass(["text-h6 q-mr-sm drag-element", { dragging: _ctx.dragging }]),
                name: "app:drag",
                onMousedown: _ctx.startDragging,
                onTouchstart: _ctx.startDragging
              }, null, 8, ["class", "onMousedown", "onTouchstart"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", {
          class: _normalizeClass({ 'q-mr-md': _ctx.fullscreenMode })
        }, [
          (_ctx.fullscreenMode)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                class: "cursor-pointer q-ml-sm text-h6",
                name: "close_fullscreen",
                onClick: _ctx.fullscreenOff
              }, null, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                class: "cursor-pointer q-ml-sm text-h6",
                name: "fullscreen",
                onClick: _ctx.fullscreenOn
              }, null, 8, ["onClick"])),
          _createVNode(_component_q_icon, {
            class: "cursor-pointer q-ml-sm text-h6",
            name: "app:close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ], 4),
    (_ctx.resizable && !_ctx.fullscreenMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "resize-control",
          onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startResizing && _ctx.startResizing(...args))),
          onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startResizing && _ctx.startResizing(...args)))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 6))
}